const defaultLanguage = 'nb';

// Main translate function
export const translate = (value, language = defaultLanguage) => {
  // 1. Split string to get keys
  const keyValues = value.split('.');

  // 2. Define variable to store result value
  let resultData = '';

  // 3. Check if language JSON file exists, else use english
  try {
    resultData = require(`./i18n/${language}.json`);
    for (const key of keyValues) {
      resultData = resultData[key];
    }
  } catch (err) {

    // DEBUG
    console.log(`Translation error: Could not find json file for <${language}>. Falling back to <${defaultLanguage}>`);

    // Failsafe language file
    resultData = require(`./i18n/nb.json`);
    for (const key of keyValues) {
      resultData = resultData[key];
    }

  }

  // Return value
  console.log(resultData)
  return resultData;
};

// TRANSLATE MODULE
const Translate = (props) => {
  return (translate(props.value, props.language));
};

export default Translate;



// WEBPACK FOOTER //
// ./src/translate.js